export const STALE_TIME = 5 * 60 * 1000;
